module.exports = __webpack_public_path__ + "img/c05_unittechgallichorsemanchampion_Normal_ua.5dcc1d6f.webp";